import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddClassForm from "../../../Components/Organisms/Forms/AddClassForm/AddClassForm";
import { MoonLoader } from "react-spinners";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClassIcon from "@mui/icons-material/Class";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import "./AddClass.css";

function AddClass({ role, Edit = false, Class, loading = false, navigate }) {
  const [classes, setClasses] = useState([]);

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <ClassIcon />
            </div>
            <div className="titleContent">
              <h1>{Edit ? "Edit Class Information" : "Add New Class"}</h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {Edit && !Class ? (
              <div className="loadingBox">
                <CircularProgress />
              </div>
            ) : (
              <AddClassForm
                role={role}
                Edit={Edit}
                Class={Class}
                url={Edit ? `classes/${Class?.id}` : ""}
                navigate={navigate}
                page={0}
                search=""
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the class profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddClass;
